"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _keymirror = _interopRequireDefault(require("keymirror"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/* eslint-disable id-length */
var _default = (0, _keymirror["default"])({
  AVAILABLE_TIMES_PERIOD_HEADER: null,
  AVAILABLE_TIMES_PERIOD_TIME: null,
  AVAILABLE_TIMES_PERIOD_EXPAND_CTA: null,
  AVAILABLE_TIME_PICKER_TIME_ZONE: null,
  AVAILABLE_TIME_PICKER_NO_AVAILABLE_TIMES_BODY: null,
  BOOKING_DATETIME: null,
  BOOKING_DETAILS_RESCHEDULE_CTA: null,
  BOOKING_LOCATION: null,
  BOOKING_QUESTIONS_QUESTION: null,
  BOOKING_QUESTIONS_ANSWER: null,
  CALENDAR_CHEVRON_LEFT: null,
  CALENDAR_CHEVRON_RIGHT: null,
  CALENDAR_DAY_PICKER_RENDERED: null,
  RESOURCE_MENU_OPENER: null,
  RESOURCE_MENU_ITEM_NAME: null,
  RESOURCE_MENU_ITEM_SPECIALTY: null,
  SEPARATOR_TEXT_LINE_TEXT: null,
  TRUNCATE_MORE_LINK: null,
  TRUNCATE_DESCRIPTION: null
});

exports["default"] = _default;